<div class="row no-gutters">
  <div class="col-12 id-nodata">
    {{'profile.noData' | i18next  }}
  </div>
</div>